export class ColumnSpan {
    columnSpan: number;
    totalColumn: number; // 1,2,3,4,6

    constructor(columnSpan: number, totalColumn: number) {
        if (columnSpan > totalColumn || ![1, 2, 3, 4, 5, 6].includes(totalColumn)) {
            throw new Error('Invalid ColumnSpan constructor parameters');
        }
        this.columnSpan = columnSpan;
        this.totalColumn = totalColumn;
    }

    getColumnSpanClass(): string {
        let columnSpanClass = 'col-md-12';
        switch (this.totalColumn) {
            case 1:
                break;
            case 2:
                if (this.columnSpan === 1) {
                    columnSpanClass = 'col-md-6';
                }
                break;
            case 3:
                if (this.columnSpan === 1) {
                    columnSpanClass = 'col-md-4';
                } else if (this.columnSpan === 2) {
                    columnSpanClass = 'col-md-8';
                }
                break;
            case 4:
                if (this.columnSpan === 1) {
                    columnSpanClass = 'col-md-3';
                } else if (this.columnSpan === 2) {
                    columnSpanClass = 'col-md-6';
                } else if (this.columnSpan === 3) {
                    columnSpanClass = 'col-md-9';
                }
                break;
            case 5:
                if (this.columnSpan === 1) {
                    columnSpanClass = 'col-md-2';
                } else if (this.columnSpan === 2) {
                    columnSpanClass = 'col-md-5';
                } else if (this.columnSpan === 3) {
                    columnSpanClass = 'col-md-7';
                } else if (this.columnSpan === 4) {
                    columnSpanClass = 'col-md-9';
                }
                break;
            case 6:
                if (this.columnSpan === 1) {
                    columnSpanClass = 'col-md-2';
                } else if (this.columnSpan === 2) {
                    columnSpanClass = 'col-md-4';
                } else if (this.columnSpan === 3) {
                    columnSpanClass = 'col-md-6';
                } else if (this.columnSpan === 4) {
                    columnSpanClass = 'col-md-8';
                } else if (this.columnSpan === 5) {
                    columnSpanClass = 'col-md-10';
                }
                break;
        }
    
        return columnSpanClass;
    }
    
}
